import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function CubeIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="m20.88 6.366-8.25-4.517a1.3 1.3 0 0 0-1.26 0L3.12 6.366a1.31 1.31 0 0 0-.682 1.151v8.966a1.31 1.31 0 0 0 .682 1.15l8.25 4.517a1.3 1.3 0 0 0 1.26 0l8.25-4.517a1.31 1.31 0 0 0 .682-1.15V7.517a1.31 1.31 0 0 0-.682-1.151m-8.974-3.531a.19.19 0 0 1 .18 0l7.837 4.29L12 11.46 4.077 7.125zm-8.25 13.811a.19.19 0 0 1-.094-.164V8.125l7.875 4.313v8.469zm16.68 0-7.774 4.26v-8.471l7.875-4.313v8.359a.19.19 0 0 1-.094.166z" fill="currentColor" />
    </BaseIcon>
  );
}
